<template>
    <div>
        <el-card v-loading="infoLoading">
            <div v-if="info" class="info-box">
                <div class="avatar">
                    <el-avatar :src="info.userAvatar | coverImage(120, 120)" :size="60"></el-avatar>
                </div>
                <div class="info">
                    <div class="head">
                        <div class="user-info">
                            <div class="user-name">{{ info.userName }}</div>
                            <div class="user-id">(ID: {{ info.userId }} )<el-button size="mini" type="text"
                                    @click="copy">
                                    复制ID
                                </el-button>
                            </div>
                        </div>
                        <div>
                            <span class="MR10">点赞: <label class="color-warning">{{ info.dingCount }} </label></span>
                            <span class="MR10">评论: <label class="color-warning">{{ info.reviewCount }}</label> </span>
                            <span>转发: <label class="color-warning">{{ info.shareCount }}</label></span>
                        </div>
                    </div>
                    <div v-if="info.topics && info.topics.length > 0" class="MT10">
                        <span v-for="(item, index) in info.topics" :key="index" class="color-blue MR10">#{{ item }}</span>
                    </div>
                    <div v-if="info.content" class="content MT10">{{ info.content }}</div>
                    <div v-if="info.photos" class="photos MT10">
                        <div v-for="(item, index) in info.photos" :key="index" class="item">
                            <el-image :src="item" fit="cover" :preview-src-list="info.photos"></el-image>
                            <div v-if="info.videoUrls && info.videoUrls.length > 0" class="play-btn"
                                @click="playVideo(index)"><span class="el-icon-video-play"></span></div>
                        </div>
                    </div>
                    <div class="MT20">
                        <el-button icon="el-icon-thumb" size="mini" @click="$refs.ding.show(info.id, 1)">点赞</el-button>
                        <el-button icon="el-icon-chat-dot-square" size="mini"
                            @click="$refs.sendReview.show(info.id, 1)">评论</el-button>
                    </div>
                </div>
            </div>
        </el-card>

        <el-card class="MT20" v-loading="reviewLoading">
            <div slot="header" class="review-header">
                <div class="title">全部评论</div>
                <div class="sort">
                    <el-radio-group v-model="sortType" size="mini" @change="reset()">
                        <el-radio-button :label="1">热度</el-radio-button>
                        <el-radio-button :label="2">最新</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="review-list">
                <div v-for="(item,index) in reviewList" :key="item.id" class="info-box">
                    <div class="avatar">
                        <el-avatar :src="item.createUserAvatar | coverImage(90, 90)" :size="30"></el-avatar>
                    </div>
                    <div class="info">
                        <div class="head">
                            <div class="user-info">
                                <div class="user-name">{{ item.createUserName }}（ID：{{item.createUser}}）</div>
                                <div class="time color-info">{{ item.createTimeStr }}</div>
                            </div>
                            <div>
                                <el-button icon="el-icon-thumb" size="mini" @click="$refs.ding.show(item.id, 2)"
                                    type="text">点赞 {{ item.dingCount }} </el-button>
                                <el-button icon="el-icon-chat-dot-square" size="mini"
                                    @click="$refs.sendReview.show(info.id, 2, item.id)" type="text">回复 {{
                                            item.reviewCount
                                    }}</el-button>
                            </div>
                        </div>
                        <div v-if="item.content" class="content MT10">{{ item.content }}</div>

                        <div v-for="sub in item.subReviews" :key="sub.id" class="info-box">
                            <div class="avatar">
                                <el-avatar :src="sub.createUserAvatar | coverImage(90, 90)" :size="30"></el-avatar>
                            </div>
                            <div class="info">
                                <div class="head">
                                    <div class="user-info">
                                        <div class="user-name">{{ sub.createUserName }}（ID：{{sub.createUser}}）</div>
                                        <div class="MR10 color-info">回复</div>
                                        <div class="user-name">{{ sub.reviewedUserName }}（ID：{{sub.reviewedUser}}）</div>
                                        <div class="time color-info">{{ sub.createTimeStr }}</div>
                                    </div>
                                    <div>
                                        <el-button icon="el-icon-thumb" size="mini" @click="$refs.ding.show(sub.id, 2)"
                                            type="text">点赞 {{ sub.dingCount }} </el-button>
                                        <el-button icon="el-icon-chat-dot-square" size="mini"
                                            @click="$refs.sendReview.show(info.id, 2, sub.id)" type="text">回复</el-button>
                                    </div>
                                </div>
                                <div v-if="sub.content" class="content MT10">{{ sub.content }}</div>
                            </div>
                        </div>
                        
                        <el-button v-if="item.subReviews && item.reviewCount > item.subReviews.length" type="text" @click="getSubReviews(item,index)">更多回复<i class="el-icon-arrow-down el-icon--right"></i></el-button>

                    </div>
                </div>
            </div>
            <div v-if="showMoreBtn" class="show-more" @click="reviewPageNo++;getReviewList()">
                <el-button>查看更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            </div>

            <div v-if="!reviewListFlag">暂无评论</div>

        </el-card>

        <VideoPlay ref="videoPlay"></VideoPlay>
        <input class="copyTool" ref="copyTool" :value="info && info.userId" />
        <ding ref="ding" @onUpdate="getInfo()"></ding>
        <send-review ref="sendReview" @onUpdate="getInfo()"></send-review>
    </div>
</template>
<script>
import VideoPlay from "@/components/VideoPlay";
import Ding from "./components/Ding.vue";
import SendReview from "./components/SendReview.vue";
export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },
    components: { VideoPlay, Ding, SendReview },
    data() {
        return {
            infoLoading: false,
            info: null,
            copyTimer: null,

            sortType: 1,
            reviewLoading: false,
            reviewList: [],
            minId: "",
            reviewPageNo: 1,
            reviewListFlag: true,
            showMoreBtn: false
        }
    },
    mounted() {
        if (this.id) {
            this.getInfo();
        }
    },
    methods: {
        //获取动态信息
        async getInfo() {
            this.infoLoading = true;
            const res = await this.$request({
                url: "/article/info",
                method: "POST",
                params: { id: this.id },
            });
            this.infoLoading = false;
            const { msg, state, result } = res.data;
            if (state != 1) return this.$message.error(msg || "请求失败");
            this.info = result;

            this.getReviewList();
        },
        //获取评论列表
        async getReviewList() {
            this.reviewLoading = true;
            const res = await this.$request({
                url: this.sortType == 1 ? "/article/review/hot-list" : "/article/review/new-list",
                method: "POST",
                params: {
                    articleId: this.id,
                    minId: this.sortType == 2 ? this.minId : "",
                    pageNo: this.reviewPageNo
                },
            });
            this.reviewLoading = false;
            const { msg, state, result } = res.data;
            if (state != 1) return this.$message.error(msg || "请求失败");

            if (result && result.length > 0) {
                this.minId = result[result.length - 1].id;

                result.map(item => {
                    const _index = this.reviewList.findIndex(v => v.id == item.id);
                    if( _index != -1 ){
                        // this.reviewList[_index] = {...item}
                        this.$set( this.reviewList, _index, {...item} )
                    }else{
                        this.reviewList.push({...item})
                    }
                })

                // this.reviewPageNo++;
                this.reviewListFlag = true;

                if( result.length >= 20 ){
                    this.showMoreBtn = true;
                }else{
                    this.showMoreBtn = false;
                }
            }else{
                this.reviewListFlag = false;
            }

        },
        reset() {
            this.reviewPageNo = 1;
            this.minId = "";
            this.reviewList = [];
            this.getReviewList();
        },

        //获取评论回复列表
        async getSubReviews(item,index){
            const res = await this.$request({
                url: "/article/review/sub-list",
                method: "POST",
                params: {
                    lastId: item.subReviews[item.subReviews.length - 1].id,
                    reviewId: item.id
                },
            });
            const { msg, state, result } = res.data;
            if (state != 1) return this.$message.error(msg || "请求失败");

            if (result.subReviews && result.subReviews.length > 0) {
                this.reviewList[index].subReviews = this.reviewList[index].subReviews.concat(result.subReviews);
            }
        },
        //复制用户ID
        copy() {
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            }, 300)
        },
        //视频播放
        playVideo(i) {
            this.$refs.videoPlay.show({ url: this.info.videoUrls[i] });
        }
    }
}
</script>

<style lang="scss" scoped>
.info-box {
    display: flex;

    .avatar {
        margin-right: 20px;
    }

    .info {
        flex: 1;

        .head {
            display: flex;
            justify-content: space-between;
            line-height: 28px;
        }

        .user-info {
            display: flex;

            .user-name {
                font-size: 15px;
                font-weight: 700;
            }

            .user-id {
                // margin-top: 8px;
                margin-left: 10px;
            }
        }


        .photos {
            display: flex;

            .item {
                width: 100px;
                height: 100px;
                margin-right: 10px;
                position: relative;

                .el-image {
                    width: 100%;
                    height: 100%;
                }

                .play-btn {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    display: flex;
                    align-content: center;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    background: rgba(0, 0, 0, .5);
                    color: #fff;
                    cursor: pointer;
                }
            }
        }
    }
}

.review-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.review-list {
    .info-box {
        margin: 20px 0;

        .head {
            justify-content: flex-start;
        }

        .user-info {
            margin-right: 20px;

            .user-name {
                font-size: 13px;
            }

            .user-id {
                margin-right: 10px;
            }
        }

        .content {
            background: #f9f9f9;
            padding: 15px;
        }
    }
}

.copyTool {
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}

.show-more {
    text-align: center;
}
</style>